import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.28558 4.66037L0 6.19246L5.36231 10.692L13.0758 1.49944L11.5437 0.213867L5.1158 7.87431L1.28558 4.66037Z",
		fill: "white"
	})
});
export default SvgCheck;
